<div #mainDiv id="mainDiv">
  <p-button
    class="map-theme-toggle"
    [rounded]="true"
    [icon]="isDarkMap ? 'pi pi-sun' : 'pi pi-moon'"
    styleClass="map-theme-toggle-btn"
    (onClick)="toggleMapTheme()"
    [pTooltip]="isDarkMap ? 'Mudar para modo claro' : 'Mudar para modo escuro'"
    tooltipPosition="right"
    ariaLabel="Alternar modo claro/escuro do mapa"
  ></p-button>
  <p-toast position="top-right" key="toastError"></p-toast>
  <p-toast position="bottom-left" key="toastAlert"></p-toast>
  <div *ngIf="loadingStatus" class="surface-card shadow-3 border-round p-1 absolute flex align-items-center justify-content-center left-50 m-auto text-xl font-semibold loadingStatus">
    <p>Carregando status dos equipamentos</p>
    <div class="flex justify-content-center align-items-center p-3 h-4rem overflow-hidden">
      <div class="circle circle-1"></div>
      <div class="circle circle-2"></div>
      <div class="circle circle-3"></div>
      <div class="circle circle-4"></div>
      <div class="circle circle-5"></div>
    </div>
  </div>
  <real-time-data-layer
    [dark]="isDarkMap"
    (layerHeatChange)="changeLayerHeat($event)"
    (layerTrafficChange)="changeLayerTraffic($event)"
    (layerTaxaChange)="changeLayerTaxa($event)"
    (layerCaminhaoChange)="changeLayerCaminhao($event)"
    (onlyWimChange)="filterOnlyWim($event)"
  ></real-time-data-layer>
  <real-time-devices-layer
  [dark]="isDarkMap"
  [dataMetrics]="dataMetrics"
  (goToLocation)="toLocation($event)"
  (filteredDevicesChange)="filterMarkersByDevices($event)"
  ></real-time-devices-layer>
  <real-time-heat-map3d
    *ngIf="this.isOpenLayers"
    (infoWindowData)="setInfoWindowData($event)"
    [(isInfoWindow)]="showInfoWindow"
  ></real-time-heat-map3d>
  <real-time-info-window
    [data]="infoWindowData"
    [dataMetrics]="devicesMarker"
    [(show)]="showInfoWindow"
  ></real-time-info-window>
  <p-blockUI *ngIf="loadingMap"  [target]="mainDiv" [blocked]="loadingMap">
    <div class="flex flex-column justify-content-center align-items-center">
      <p-progressSpinner
      styleClass="block m-auto"
      styleClass="w-4rem h-4rem"
      strokeWidth="8"/>
      <label class="block m-auto text-3xl font-semibold text-blue-900">Sincronizando dados do mapa</label>

    </div>
  </p-blockUI>

  <p-dialog
    class="loading"
    [showHeader]="false"
    [modal]="false"
    [(visible)]="loading"
    [style]="{ width: '100px', height: '100px' }"
    [baseZIndex]="10000"
  >
    <div>
      <p-progressSpinner id="loading"></p-progressSpinner>
    </div>
  </p-dialog>
</div>
